import { PipeTransform, Pipe, Injectable } from '@angular/core';

@Pipe({
    name: 'filterby'
})
@Injectable()
export class FilterPipe implements PipeTransform {
    transform(items: any[], field: string, value: string, subField?: string): any[] {
        if (!items) return [];
        if (!value || value.length == 0) return items;
        if (!subField) {
            return items.filter(it =>
                it[field].toLowerCase().indexOf(value.toLowerCase().trim()) != -1);
        } else {
            return items.filter(it =>
                it[field][subField].toLowerCase().indexOf(value.toLowerCase().trim()) != -1);
        }

    }
}